import { MessageDescriptor } from 'react-intl';
import { SMLRouteNames, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { SMLSectionTab } from '../components/SMLSectionTabs/SMLSectionTabs';
import { smlNavigationMessages } from '../navigation/smlNavigationMessages';

/** The routes that are a tab of Charts. */
export type ChartsTabScreen =
  | SMLRouteNames.trends
  | SMLRouteNames.artists
  | SMLRouteNames.tracks
  | SMLRouteNames.playlists
  | SMLRouteNames.markets;

/** The name of each Charts tab, also the crumb and the back link of a page under it. */
export const chartsTabLabels: Record<ChartsTabScreen, MessageDescriptor> = {
  [SMLRouteNames.trends]: smlNavigationMessages.trends,
  [SMLRouteNames.artists]: smlNavigationMessages.artists,
  [SMLRouteNames.tracks]: smlNavigationMessages.tracks,
  [SMLRouteNames.playlists]: smlNavigationMessages.playlists,
  [SMLRouteNames.markets]: smlNavigationMessages.markets,
};

const ORDER: ChartsTabScreen[] = [
  SMLRouteNames.trends,
  SMLRouteNames.artists,
  SMLRouteNames.tracks,
  SMLRouteNames.playlists,
  SMLRouteNames.markets,
];

/**
 * The tabs of Charts (design navigation-v2 e 5a, 5b): Trends, Artists, Tracks, Playlists, Markets.
 * Each tab is its old route. An artist, a track or a playlist is a page under Charts, not a tab.
 */
export function chartsTabs(screen: SMLRouteNames | undefined): SMLSectionTab[] {
  return ORDER.map((tab) => ({
    id: tab,
    label: chartsTabLabels[tab],
    route: SMLRoutes[tab],
    active: screen === tab,
  }));
}
